module.exports = __webpack_public_path__ + "static/BannerPhone-f979d31f452d78a483996f2ee0ac400e.png";